import { useEffect } from 'react';
import axios from 'axios';

const getScreenType = (): string => {
  const width = window.innerWidth;
  if (width < 576) return 'xs';
  if (width < 768) return 'sm';
  if (width < 992) return 'md';
  if (width < 1200) return 'lg';
  return 'xl';
};

const useViewportEngagement = (section: string) => {
  useEffect(() => {
    const screenType = getScreenType();

    const sendEngagement = async () => {
      try {
        let data;
        data = {
          section,
          type: 'viewport',
          value: { screenType },
          timestamp: new Date().toISOString(),
          pageUrl: window.location.href,
        };
        console.log('Sending viewport engagement:', data);
        await axios.post('/api/engagement', data);
      } catch (error) {
        console.error(`Viewport engagement failed for [${section}]`, error);
      }
    };

    sendEngagement();
  }, [section]);
};

export default useViewportEngagement;
